var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('card',{staticClass:"stacked-form"},[_c('product-category-form',{attrs:{"init-product-category":{},"val-errors":_vm.valErrors,"product-categories":_vm.productCategories,"submit-text":"Erstellen"},on:{"submit":_vm.submit}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }